import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class HeightBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.height = {
            update: (element: HTMLElement, valueAccessor: () => any) => {
                let height = ko.unwrap(valueAccessor());

                $(element).height(height);
            }
        };
    }
}